export default {"src":"/_next/static/media/close_basic_icon.dbc58044.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};